import {formatCurrencyCode, replaceDotToComma, splitNumber} from "../../../../models/amount/amount.helper";
import {Amount, AmountUnsafe} from "../../../../models/amount/amount";

export enum DisplayType {
    DOT = 'dot',
    COMMA = 'comma'
}

export const formatWithDot = (value: Amount): string => {
    return splitNumber(value.value.toFixed(2)) + " " + formatCurrencyCode(value.currencyCode);
}

export const formatWithComma = (value: Amount) => {
    return replaceDotToComma(splitNumber(value.value.toFixed(2)))  + " " + formatCurrencyCode(value.currencyCode);
}

export const format = (value: AmountUnsafe, type: DisplayType): string => {

    const currencyCode = value.currencyCode;
    let priceValue = value.value;

    if (typeof priceValue !== "number") {
        priceValue = parseFloat(priceValue)
    }

    switch (type) {
        case DisplayType.DOT:
            return formatWithDot({currencyCode: currencyCode, value: priceValue});
        case DisplayType.COMMA:
            return formatWithComma({currencyCode: currencyCode, value: priceValue});
        default:
            return priceValue.toFixed(2);
    }
}